module.exports = __webpack_public_path__ + "files/6b20f5b904e82b68a273f04c58d32fdd.png";